import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  public all: string[] = ['C', 'C#', 'D', 'Eb', 'E', 'F', 'F#', 'G', 'G#', 'A', 'Bb', 'B'];
  public allAlt: string[] = ['C', 'Db', 'D', 'D#', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'A#', 'B'];
  public allSharp: string[] = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
  public allFlat: string[] = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
  public allSharpDo: string[] = ['Do', 'Do#', 'Ré', 'Ré#', 'Mi', 'Fa', 'Fa#', 'Sol', 'Sol#', 'La', 'La#', 'Si'];
  public allFlatDo: string[] = ['Do', 'Réb', 'Ré', 'Mib', 'Mi', 'Fa', 'Solb', 'Sol', 'Lab', 'La', 'Sib', 'Si'];
  public allDo: string[] = ['Do', 'Do#', 'Ré', 'Mib', 'Mi', 'Fa', 'Fa#', 'Sol', 'Sol#', 'La', 'Sib', 'Si'];
  public allAltDo: string[] = ['Do', 'Réb', 'Ré', 'Ré#', 'Mi', 'Fa', 'Solb', 'Sol', 'Lab', 'La', 'La#', 'Si'];
  public allDouble = ['C', 'C#/Db', 'D', 'D#/Eb', 'E', 'F', 'F#/Gb', 'G', 'G#/Ab', 'A', 'A#/Bb', 'B'];
  public allDoubleDo = ['Do', 'Do#/Réb', 'Ré', 'Ré#/Mib', 'Mi', 'Fa', 'Fa#/Solb', 'Sol', 'Sol#/Lab', 'La', 'La#/Sib', 'Si'];
  public allAltAndSharp = ['C', 'C#', 'Db', 'D', 'D#', 'Eb', 'E', 'F', 'F#', 'Gb', 'G', 'G#', 'Ab', 'A', 'A#', 'Bb', 'B'];
  public allAltAndSharpDo = [
    'Do', 'Do#', 'Réb', 'Ré', 'Ré#', 'Mib', 'Mi', 'Fa', 'Fa#', 'Solb', 'Sol', 'Sol#', 'Lab', 'La', 'La#', 'Sib', 'Si'
  ];

  public internationalNotesTitles = ['Français', 'Deutsch', 'English', 'Español', 'Italiano',
  'Português', 'Nederlands</br>(België)', 'Nederlands<br/>(Nederland)', 'Românesc', 'русский', '日本の'];

  public internationalNotes = [
//    [11, 'do bémol', 'Ces', 'C flat', 'do bemol', 'do bemolle', 'dó bemol', 'do mol', 'Ces', 'do bemol', 'до-бемоль', '変ハ' ],
    [0, 'do (Ut)', 'C', 'C', 'do', 'do', 'dó', 'do', 'C', 'do', 'до', 'ハ' ],
    [1, 'do dièse', 'Cis', 'C sharp', 'do sostenido', 'do diesis', 'dó sustenido', 'do kruis', 'Cis', 'do diez', 'до-диез', '嬰ハ' ],
    [1, 'ré bémol', 'Des', 'D flat', 're bemol', 're bemolle', 'ré bemol', 're mol', 'Des', 're bemol', 'ре-бемоль', '変ニ' ],
    [2, 'ré', 'D', 'D', 're', 're', 'ré', 're', 'D', 're', 'ре', 'ニ' ],
    [3, 'ré dièse', 'Dis', 'D sharp', 're sostenido', 're diesis', 'ré sustenido', 're kruis', 'Dis', 're diez', 'ре-диез', '嬰ニ' ],
    [3, 'mi bémol', 'Es', 'E flat', 'mi bemol', 'mi bemolle', 'mi bemol', 'mi mol', 'Es', 'mi bemol', 'ми-бемоль', '変ホ' ],
    [4, 'mi', 'E', 'E', 'mi', 'mi', 'mi', 'mi', 'E', 'mi', 'ми', 'ホ' ],
//    [5, 'mi dièse', 'Eis', 'E sharp', 'mi sostenido', 'mi diesis', 'mi sustenido', 'mi kruis', 'Eis', 'mi diez', 'ми-диез', '嬰ホ' ],
//    [4, 'fa bémol', 'Fes', 'F flat', 'fa bemol', 'fa bemolle', 'fá bemol', 'fa mol', 'Fes', 'fa bemol', 'фа-бемоль', '変ヘ' ],
    [5, 'fa', 'F', 'F', 'fa', 'fa', 'fá', 'fa', 'F', 'fa', 'фа', 'ヘ' ],
    [6, 'fa dièse', 'Fis', 'F sharp', 'fa sostenido', 'fa diesis', 'fá sustenido', 'fa kruis', 'Fis', 'fa diez', 'фа-диез', '嬰ヘ' ],
    [6, 'sol bémol', 'Ges', 'G flat', 'sol bemol', 'sol bemolle', 'sol bemol', 'sol mol', 'Ges', 'sol bemol', 'соль-бемоль', '変ト' ],
    [7, 'sol', 'G', 'G', 'sol', 'sol', 'sol', 'sol', 'G', 'sol', 'соль', 'ト' ],
    [8, 'sol dièse', 'Gis', 'G sharp', 'sol sostenido', 'sol diesis', 'sol sustenido', 'sol kruis', 'Gis', 'sol diez', 'соль-диез', '嬰ト' ],
    [8, 'la bémol', 'As', 'A flat', 'la bemol', 'la bemolle', 'lá bemol', 'la mol', 'As', 'la bemol', 'ля-бемоль', '変イ' ],
    [9, 'la', 'A', 'A', 'la', 'la', 'lá', 'la', 'A', 'la', 'ля', 'イ' ],
    [10, 'la dièse', 'Ais', 'A sharp', 'la sostenido', 'la diesis', 'lá sustenido', 'la kruis', 'Ais', 'la diez', 'ля-диез', '嬰イ'],
    [10, 'si bémol', 'B', 'B flat', 'si bemol', 'si bemolle', 'si bemol', 'si mol', 'Bes', 'si bemol', 'си-бемоль', '変ロ' ],
    [11, 'si', 'H', 'B', 'si', 'si', 'si', 'si', 'B', 'si', 'си', 'ロ' ]
    //    [0, 'si dièse', 'His', 'B sharp', 'si sostenido', 'si diesis', 'si sustenido', 'si kruis', 'Bis', 'si diez', 'си-диез', '嬰ロ' ]
  ];
  public colors: string[] = [];
  constructor() {
    const m = 12;
    this.colors.push(
      'rgb(' + (0 * m) + ',' + (6 * m) + ',' + (1 * m) + ')',
      'rgb(' + (0 * m) + ',' + (4 * m) + ',' + (2 * m) + ')',
      'rgb(' + (0 * m) + ',' + (3 * m) + ',' + (3 * m) + ')',
      'rgb(' + (0 * m) + ',' + (2 * m) + ',' + (4 * m) + ')',
      'rgb(' + (1 * m) + ',' + (1 * m) + ',' + (6 * m) + ')',
      'rgb(' + (2 * m) + ',' + (0 * m) + ',' + (4 * m) + ')',
      'rgb(' + (3 * m) + ',' + (0 * m) + ',' + (3 * m) + ')',
      'rgb(' + (4 * m) + ',' + (0 * m) + ',' + (2 * m) + ')',
      'rgb(' + (6 * m) + ',' + (1 * m) + ',' + (1 * m) + ')',
      'rgb(' + (4 * m) + ',' + (2 * m) + ',' + (0 * m) + ')',
      'rgb(' + (3 * m) + ',' + (3 * m) + ',' + (0 * m) + ')',
      'rgb(' + (2 * m) + ',' + (3 * m) + ',' + (0 * m) + ')'
    );
  }

  disp(note: number, doremi = false) {
    if (doremi) {
      return this.dispDo(note);
    }
    return this.all[(note + 240) % 12];
  }
  dispDo(note: number) {
    return this.allDo[(note + 240) % 12];
  }
  dispSharp(note: number, doremi = false) {
    return doremi ? this.allSharpDo[(note + 240) % 12] : this.allSharp[(note + 240) % 12];
  }
  dispFlat(note: number, doremi = false) {
    return doremi ? this.allFlatDo[(note + 240) % 12] : this.allFlat[(note + 240) % 12];
  }
  dispWithOctave(note: number, doremi = false) {
    return this.disp(note, doremi) + Math.floor(note / 12);
  }
  dispDouble(note: number, doremi?: boolean) {
    if (doremi) {
      return this.allDoubleDo[(note + 240) % 12];
    }
    return this.allDouble[(note + 240) % 12];
  }
  getStrictNoteName(
    from: string,
    increment: number,
    realDelta: number,
    doremi: boolean): string {
    // console.log(from, increment, realDelta);
    if ((increment === 0) && (realDelta === 0)) {
      return from;
    }
    let inc = 0;
    let nudeNote = '';
// tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < from.length; i++) {
      if (from[i] === '#') {
        inc++;
      } else if (from[i] === 'b') {
        inc--;
      } else {
        nudeNote += from[i];
      }
    }
    from = nudeNote;
    if (doremi) {
      const translate1: {[key: string]: string} = {
          Do : 'C',
          Ré : 'D',
          Mi : 'E',
          Fa : 'F',
          Sol : 'G',
          La : 'A',
          Si : 'B'
      };
      from = translate1[from];
    }
    const fromNote = from;
    const fromIndex = 'C D EF G A B'.indexOf(fromNote) + inc;
    let targetNoteName = 'CDEFGAB'[('CDEFGAB'.indexOf(fromNote) + increment) % 7];
    const targetIndex = 'C D EF G A B'.indexOf(targetNoteName);
    if (doremi) {
      const translate2: {[key: string]: string} = {
          C : 'Do',
          D : 'Ré',
          E : 'Mi',
          F : 'Fa',
          G : 'Sol',
          A : 'La',
          B : 'Si'
      };
      targetNoteName = translate2[targetNoteName];
    }
    let diff = (targetIndex - fromIndex - realDelta) % 12;
    if (diff < -6) {
      diff += 12;
    }
    if (diff > 6) {
      diff -= 12;
    }
    let add = 'b';
    if (diff < 0) {
      add = '#';
    }
    for (let i = 0; i < Math.abs(diff); i++) {
      targetNoteName += add;
    }
    return targetNoteName;
  }
  getFifth(from: string, doremi: boolean) {
    return this.getStrictNoteName(from, 4, 7, doremi);
  }
  getSixth(from: string, doremi: boolean) {
    return this.getStrictNoteName(from, 5, 9, doremi);
  }
  getSeventh(from: string, doremi: boolean) {
    return this.getStrictNoteName(from, 6, 11, doremi);
  }
  getFourth(from: string, doremi: boolean) {
    return this.getStrictNoteName(from, 3, 5, doremi);
  }
  // Gb ==> F#,  E# ==> F ...
  invertSharpFlat(note: string): string {
    const sharp = this.allSharp.indexOf(note);
    if (sharp !== -1) {
      return this.allFlat[sharp];
    }
    const flat = this.allFlat.indexOf(note);
    if (flat !== -1) {
      return this.allSharp[flat];
    }
    let inc = 0;
    let nudeNote = '';
// tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < note.length; i++) {
      if (note[i] === '#') {
        inc++;
      } else if (note[i] === 'b') {
        inc--;
      } else {
        nudeNote += note[i];
      }
    }

    const note12 = (this.all.indexOf(nudeNote) + inc) % 12;
    if (inc < 0) {
      return this.allSharp[note12];
    }
    return this.allFlat[note12];
  }
  noteToIndex(note: string) {
    let result = this.all.indexOf(note);
    if (result === -1) {
      result = this.allAlt.indexOf(note);
    }
    if (result === -1) {
      result = this.allDo.indexOf(note);
    }
    if (result === -1) {
      result = this.allAltDo.indexOf(note);
    }
    return result;
  }
  frequency(note: number) {
    const pow = (note - 49) / 12;
    return 440 * Math.pow(2, pow);
  }
  altAndSharpToIndex(note: string, doremi: boolean) {
    const index = doremi ? this.allAltAndSharpDo.indexOf(note) : this.allAltAndSharp.indexOf(note);
    return [0, 1, 1, 2, 3, 3, 4, 5, 6, 6, 7, 8, 8, 9, 10, 10, 11][index];
  }
  getNoteFromDoremi(note: string, doremi: boolean): string {
    let index = this.allAltAndSharp.indexOf(note);
    if (index === -1) {
      index = this.allAltAndSharpDo.indexOf(note);
    }
    return doremi ? this.allAltAndSharpDo[index] : this.allAltAndSharp[index];
  }
}
